import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminAPI } from "../../api/api";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUserCircle, FaLock, FaSignOutAlt } from "react-icons/fa";

export default function AccountSettings() {
  const [user, setUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await AdminAPI.me();
        setUser(data);
      } catch (err) {
        console.error("Error al obtener administrador:", err);
        setMessage({ type: "danger", text: "No se pudo cargar la información del usuario." });
        navigate("/login");
      }
    };
    fetchUser();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await AdminAPI.logout();
      window.location.href = "/login";
    } catch (err) {
      console.error("Error al cerrar sesión:", err);
    }
  };

  const handleChangePassword = async () => {
    setMessage(null);

    if (!newPassword || !confirmPassword) {
      setMessage({ type: "danger", text: "Completa ambos campos." });
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage({ type: "danger", text: "Las contraseñas no coinciden." });
      return;
    }

    if (newPassword.length < 6) {
      setMessage({ type: "danger", text: "La contraseña debe tener al menos 6 caracteres." });
      return;
    }

    setLoading(true);
    try {
      await AdminAPI.cambiarContrasena(newPassword);
      setMessage({ type: "success", text: "Contraseña cambiada correctamente." });
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error(error);
      setMessage({ type: "danger", text: "Hubo un error al cambiar la contraseña." });
    } finally {
      setLoading(false);
    }
  };

  if (!user) return <p className="text-center mt-5">Cargando información del usuario...</p>;

  return (
    <div className="container py-5">
      <div
        className="card mx-auto shadow-lg"
        style={{
          maxWidth: "480px",
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div className="card-header bg-primary text-white text-center py-4">
          <FaUserCircle size={55} className="mb-2" />
          <h5 className="mb-0">Mi cuenta</h5>
        </div>

        {/* Body */}
        <div className="card-body">

          <div className="text-center mb-3">
            <p className="mb-1">
              <strong>Nombre:</strong> {user.nombreCompleto}
            </p>
            <p className="text-muted">
              <strong>Email:</strong> {user.correo}
            </p>
          </div>

          <hr />

          {message && (
            <div className={`alert alert-${message.type}`} role="alert">
              {message.text}
            </div>
          )}

          <h6 className="fw-bold mb-3">Cambiar contraseña</h6>

          <div className="mb-3">
            <label className="form-label">Nueva contraseña</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Ingresa nueva contraseña"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Confirmar contraseña</label>
            <input
              type="password"
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirma nueva contraseña"
            />
          </div>

          <button
            className="btn btn-success w-100 mb-3 d-flex align-items-center justify-content-center gap-2 py-2"
            onClick={handleChangePassword}
            disabled={loading}
          >
            <FaLock />
            {loading ? "Cambiando..." : "Cambiar contraseña"}
          </button>

          <button
            className="btn btn-outline-danger w-100 d-flex align-items-center justify-content-center gap-2 py-2"
            onClick={handleLogout}
          >
            <FaSignOutAlt />
            Cerrar sesión
          </button>
        </div>

        {/* Footer */}
        <div className="card-footer text-center text-muted py-3">
          &copy; {new Date().getFullYear()} Inerva Psicología
        </div>
      </div>
    </div>
  );
}
